// Menú del Entorno Grupo (Administradores de Grupo)
const MenuGrupo = [
  {
    title: 'Admin Grupo',
    group: 'main',
    icon: 'mdi-shield-account',
    name: 'GrupoAdmins',
    hint: 'Administradores de Grupo'
  },
  {
    title: 'Concesionarios',
    group: 'main',
    icon: 'mdi-store',
    name: 'GrupoDealers',
    hint: 'Concesionarios del grupo'
  },
  {
    title: 'Partners',
    group: 'main',
    icon: 'mdi-handshake',
    name: 'GrupoPartners',
    hint: 'Dealers que comparten stock'
  },
  {
    title: 'Colaboradores',
    group: 'main',
    icon: 'mdi-account-hard-hat',
    name: 'GrupoColaboradores',
    hint: 'Talleres, lavaderos y otras empresas externas'
  },
  {
    title: 'Usuarios',
    group: 'main',
    icon: 'mdi-account-group',
    name: 'GrupoUsers',
    hint: 'Usuarios de los dealers del grupo'
  },
  {
    title: 'Grúas',
    group: 'main',
    icon: 'mdi-tow-truck',
    name: 'GrupoGruas',
    hint: 'Empresas de grúa del grupo'
  },
  {
    title: 'Ubicaciones',
    group: 'main',
    icon: 'mdi-map-marker',
    name: 'GrupoUbicaciones',
    hint: 'Ubicaciones de los dealers del grupo'
  },
  {
    title: 'Permisos',
    group: 'main',
    icon: 'mdi-shield-key',
    name: 'GrupoPermisos',
    hint: 'Permisos predefinidos por rol'
  },
  {
    title: 'Comodato',
    group: 'main',
    icon: 'mdi-text-box-multiple-outline',
    name: 'GrupoComodato',
    hint: 'Plantillas de comodato del grupo'
  },
  {
    title: 'Reportes',
    group: 'main',
    icon: 'mdi-file-chart-outline',
    name: 'Reportes',
    hint: 'Consulte y descargue los reportes del grupo',
    items: [
      { name: 'Reporte1', title: 'Movimientos pendientes y antigüedad' },
      { name: 'Reporte2', title: 'Uso real de la herramienta' },
      { name: 'Reporte3', title: 'Cesiones y comodatos' },
      { name: 'Reporte4', title: 'Stock inmovilizado' },
      { name: 'Reporte5', title: 'Daños detectados' },
      { name: 'Reporte6', title: 'Vehículos pendientes de llegada' }
    ]
  },
  {
    title: 'Configuración',
    group: 'main',
    icon: 'mdi-cog',
    name: 'GrupoConfiguracion',
    hint: 'Tus datos personales'
  },
  {
    title: 'Asistente Virtual',
    group: 'main',
    icon: 'mdi-robot-outline',
    name: 'GrupoChatbot',
    isChatbot: true,
    hint: 'Asistente con la información de tu grupo, filtrable por concesionario'
  }
]

export default MenuGrupo
